import { render, staticRenderFns } from "./AccidentBase.vue?vue&type=template&id=4ee57908&scoped=true"
import script from "./AccidentBase.vue?vue&type=script&lang=js"
export * from "./AccidentBase.vue?vue&type=script&lang=js"
import style0 from "./AccidentBase.vue?vue&type=style&index=0&id=4ee57908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee57908",
  null
  
)

export default component.exports